export default {
  namespaced: true,
  state: () => ({
    url: null,
    text: null,
    subText: null,
    photo: null,
    user: null,
    height: 58
  }),
  getters: {
    url: state => state.url,
    text: state => state.text,
    subText: state => state.subText,
    photo: state => state.photo,
    user: state => state.user,
    height: state => state.height
  },
  mutations: {
    set (state, { url, text, subText, photo, user, back }) {
      state.url = url
      state.text = text
      state.subText = subText
      state.photo = photo
      state.user = user
    },
    reset (state) {
      state.url = null
      state.text = null
      state.subText = null
      state.photo = null
      state.user = null
    },
    setHeight (state, height) {
      state.height = height
    }
  }
}
